import axiosInstance from '../axios/axios-instance';
import { CreateUserSettingRequest } from './dto/create-user-setting-request.dto';
import { GetUserSettingsResponse } from 'shared/interfaces/user-settings/get-user-settings-response.dto';

export const userSetting = {
  /**
   * Fetches the user settings.
   * @returns A promise that resolves to the user settings.
   */
  async fetchUserSettings(): Promise<GetUserSettingsResponse> {
    const response = await axiosInstance.get<GetUserSettingsResponse>('/user-setting');
    return response.data;
  },

  /**
   * Creates or updates a user setting.
   * @param userSetting - The user setting to create or update.
   */
  async createOrUpdateUserSetting(userSetting: CreateUserSettingRequest): Promise<void> {
    await axiosInstance.post('/user-setting', userSetting);
  },
};
